import { render, staticRenderFns } from "./PrepTermListView.vue?vue&type=template&id=1fbb0528&scoped=true"
import script from "./PrepTermListView.vue?vue&type=script&lang=js"
export * from "./PrepTermListView.vue?vue&type=script&lang=js"
import style0 from "./PrepTermListView.vue?vue&type=style&index=0&id=1fbb0528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbb0528",
  null
  
)

export default component.exports